// src/components/PrivacyPolicy.js
import React from "react";
import "../css/privacyPolicy.css";

function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <h1 className="privacy-title">Privacy Policy</h1>
      <p className="privacy-intro">
        Your privacy matters. Here's how we protect your data at QueryBox, a product by Retreeval Technologies.
      </p>

      <h2 className="privacy-subtitle">1. Information We Collect</h2>
      <p>
        We collect personal information you provide when signing up, such as your name, email, and organization details.
        We may also gather usage data, device information, and cookies to improve your experience.
      </p>

      <h2 className="privacy-subtitle">2. How We Use Your Data</h2>
      <p>
        We use your data to deliver, maintain, and improve QueryBox services. This includes analyzing usage patterns,
        personalizing experiences, and sending important updates.
      </p>

      <h2 className="privacy-subtitle">3. Sharing & Disclosure</h2>
      <p>
        We do not sell your personal information. We may share it with trusted partners or service providers who
        help operate QueryBox, under strict confidentiality agreements.
      </p>

      <h2 className="privacy-subtitle">4. Data Security</h2>
      <p>
        We implement best-in-class security measures including encryption, authentication, and access controls to
        protect your information at all times.
      </p>

      <h2 className="privacy-subtitle">5. Your Rights</h2>
      <p>
        You have the right to access, update, or delete your personal data at any time. Contact us at{" "}
        <a href="mailto:support@retreeval.com">support@retreeval.com</a> for requests or questions.
      </p>

      <h2 className="privacy-subtitle">6. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy to reflect changes in law or service improvements. We'll notify you of
        significant changes via email or in-app messages.
      </p>

      <p className="privacy-updated">
        <em>Last updated: September 18, 2025</em>
      </p>
    </div>
  );
}

export default PrivacyPolicy;
